export enum Namespaces {
    scientific = "scientific"
}
